import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-43">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white to-brand-50/50" data-id="element-44"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-46">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-8" data-id="element-47">
            El próximo domingo...
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-600 mb-12" data-id="element-48">
            <p data-id="element-49">
              El próximo domingo podés estar como siempre: buscando actividades
              a último momento, armando material con lo que encontrás, llegando
              al lunes con la planificación a medio hacer...
            </p>
            <p className="font-bold text-brand-700 text-2xl" data-id="element-50">
              O podés tener TODO tu año resuelto.
            </p>
            <p data-id="element-51">
              Cada semana planificada. Cada actividad secuenciada. Cada rúbrica
              lista. Cada informe con plantilla.
            </p>
            <p className="font-black text-gray-900 text-2xl pt-4" data-id="element-52">
              Vos elegís.
            </p>
          </div>

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-brand-600 hover:bg-brand-700 text-white text-xl font-black py-5 px-10 rounded-full shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 mb-6" data-id="element-53">
            Elegí tu MegaPack ahora
          </button>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-500 font-medium" data-id="element-54">
            <Lock className="w-4 h-4" data-id="element-55" />
            Pago 100% seguro · Mercado Pago · Tarjeta · Transferencia
          </div>
        </motion.div>
      </div>
    </section>;
}